$( document ).ready(function() {

    $(document).on("submit", "#cgatGPTForm", function(e){

        e.preventDefault();

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        const form = $(this);
        const url  = form.attr("action");
        const data = new FormData(this);

        // $('#subscriptionMessage').remove();

        $.ajax({
            type 		: "POST",
            url 		: url,
            data 		: data,
            dataType 	: 'json',
            contentType : false,
            cache 		: false,
            processData : false,

            success: function(data) {
                form.replaceWith(data.message)
            },

            error: function(data) {
                form.append(`<span id="subscriptionMessage"><strong>The operation failed. Please try again later!</strong></span>`)
            },
        });
    });
});